module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/assets/MaterialIcons/iconfont/MaterialIcons-Regular.woff
// module id = ../../../../../src/assets/MaterialIcons/iconfont/MaterialIcons-Regular.woff
// module chunks = styles